import { AssignPeoplePermissionsEnum } from '@shared/enums/assignPeoplePermissions.enum';
import { ModalNamesEnum } from '@shared/enums/modalNames.enum';
import { PackageEnum } from '@shared/enums/package.enum';
import { PlannerItemModelTypeEnum } from '@shared/enums/plannerItemModelType.enum';
import { PlannerItemStatusesEnum } from '@shared/enums/plannerItemStatuses.enum';
import { getModalByName } from '@shared/functions/getModalByName';

import modalObserver from '../../shared/utils/observers/modalObserver';
import { getAppointment } from '../appointments/appointmentsThunk';
import { getEvent } from '../events/eventsThunk';
import { getMeeting } from '../meetings/meetingsThunk';
import { getReminder } from '../reminders/remindersThunk';
import { getTask } from '../roadmap/roadmapThunk';

import { addedCalendarItem, removeCalendarItem, updateCalendarItem } from './calendarSlice';

import type { AppDispatch } from '../store';
import type { PlannerItemSocketType } from '@setup/socket/GeneralSockets/GeneralSockets';

export const calendarSocketUpdateItem = (event: PlannerItemSocketType) => (dispatch: AppDispatch) => {
  if (event?.item?.model_type === PlannerItemModelTypeEnum.task) {
    dispatch(getTask({ taskId: event.item.id, is_list: 1 })).then((result) => {
      if (getTask.fulfilled.match(result)) {
        if (getTask.fulfilled.match(result)) {
          if (
            (!!result.payload.current_user.status ||
              result.payload.current_user.role !== AssignPeoplePermissionsEnum.creator) &&
            result.payload.started_at &&
            result.payload.global_status !== PlannerItemStatusesEnum.backlog
          ) {
            dispatch(updateCalendarItem(result.payload));
          } else {
            dispatch(removeCalendarItem(result.payload.id));
          }
        }

        const modal = getModalByName(ModalNamesEnum.viewTaskModal);
        if (modal?.isOpen && modal?.props?.taskId === `${event.item.id}`) {
          modalObserver.updateModalProps(ModalNamesEnum.viewTaskModal, {
            props: {
              data: result.payload,
            },
          });
        }
      }
    });
  } else if (event?.item?.model_type === PlannerItemModelTypeEnum.event) {
    dispatch(getEvent({ eventId: event.item.id })).then((result) => {
      if (getEvent.fulfilled.match(result)) {
        dispatch(updateCalendarItem(result.payload));
        const modal = getModalByName(ModalNamesEnum.viewEventModal);
        if (modal?.isOpen && modal?.props?.eventId === `${event.item.id}`) {
          modalObserver.updateModalProps(ModalNamesEnum.viewEventModal, {
            props: {
              data: result.payload,
            },
          });
        }
      }
    });
  } else if (event?.item?.model_type === PlannerItemModelTypeEnum.meet) {
    dispatch(getMeeting({ meetingId: event.item.id })).then((result) => {
      if (getMeeting.fulfilled.match(result)) {
        dispatch(updateCalendarItem(result.payload));
        const modal = getModalByName(ModalNamesEnum.viewMeetingModal);
        if (modal?.isOpen && modal?.props?.meetId === `${event.item.id}`) {
          modalObserver.updateModalProps(ModalNamesEnum.viewMeetingModal, {
            props: {
              data: result.payload,
            },
          });
        }
      }
    });
  } else if (event?.item?.model_type === PlannerItemModelTypeEnum.appointment) {
    dispatch(getAppointment({ appointmentId: event.item.id })).then((result) => {
      if (getAppointment.fulfilled.match(result)) {
        dispatch(updateCalendarItem(result.payload));
        const modal = getModalByName(ModalNamesEnum.viewAppointmentModal);
        if (modal?.isOpen && modal?.props?.appointmentId === `${event.item.id}`) {
          modalObserver.updateModalProps(ModalNamesEnum.viewAppointmentModal, {
            props: {
              data: result.payload,
            },
          });
        }
      }
    });
  } else if (event?.item?.model_type === PlannerItemModelTypeEnum.reminder) {
    dispatch(getReminder({ reminderId: event.item.id })).then((result) => {
      if (getReminder.fulfilled.match(result)) {
        dispatch(updateCalendarItem(result.payload));
        const modal = getModalByName(ModalNamesEnum.viewReminderModal);
        if (modal?.isOpen && modal?.props?.reminderId === `${event.item.id}`) {
          modalObserver.updateModalProps(ModalNamesEnum.viewReminderModal, {
            props: {
              data: result.payload,
            },
          });
        }
      }
    });
  }
};

export const calendarSocketAddItem =
  (event: PlannerItemSocketType) => (dispatch: AppDispatch, getState: any) => {
    const userPackage = getState().profile?.data?.subscription?.package;
    const isStarterPackage = userPackage === PackageEnum.starter || !userPackage;

    if (event?.item?.model_type === PlannerItemModelTypeEnum.task) {
      dispatch(getTask({ taskId: event.item.id, is_list: 1 })).then((result) => {
        if (getTask.fulfilled.match(result)) {
          if (
            (!!result.payload.current_user.status ||
              result.payload.current_user.role !== AssignPeoplePermissionsEnum.creator) &&
            result.payload.started_at &&
            result.payload.global_status !== PlannerItemStatusesEnum.backlog
          ) {
            dispatch(addedCalendarItem({ data: result.payload, isStarterPackage }));
          }
        }
      });
    } else if (event?.item?.model_type === PlannerItemModelTypeEnum.event) {
      dispatch(getEvent({ eventId: event.item.id })).then((result) => {
        if (getEvent.fulfilled.match(result)) {
          dispatch(addedCalendarItem({ data: result.payload, isStarterPackage }));
        }
      });
    } else if (event?.item?.model_type === PlannerItemModelTypeEnum.meet) {
      dispatch(getMeeting({ meetingId: event.item.id })).then((result) => {
        if (getMeeting.fulfilled.match(result)) {
          dispatch(addedCalendarItem({ data: result.payload, isStarterPackage }));
        }
      });
    } else if (event?.item?.model_type === PlannerItemModelTypeEnum.appointment) {
      dispatch(getAppointment({ appointmentId: event.item.id })).then((result) => {
        if (getAppointment.fulfilled.match(result)) {
          dispatch(addedCalendarItem({ data: result.payload, isStarterPackage }));
        }
      });
    } else if (event?.item?.model_type === PlannerItemModelTypeEnum.reminder) {
      dispatch(getReminder({ reminderId: event.item.id })).then((result) => {
        if (getReminder.fulfilled.match(result)) {
          dispatch(addedCalendarItem({ data: result.payload, isStarterPackage }));
        }
      });
    }
  };
